import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IWorkspaceSwitcherState} from "../reducers/workspace-switcher.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getWorkspaceSwitcherState = createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.workspaceSwitcher);

export const getWorkspaceSwitching = createSelector(getWorkspaceSwitcherState,
  (state: IWorkspaceSwitcherState): IWorkspaceSwitcherState => state
);
